'use strict';

var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');
var SystemIcon_constants = require('./SystemIcon.constants.js');

/**
 * 시스템 아이콘을 표시하는 컴포넌트입니다.
 * 크기별(small, medium, large) 및 소셜 아이콘을 지원합니다.
 *
 * @param {Object} props - 컴포넌트 속성
 * @param {string} props.name - 아이콘의 이름 (예: 'small_close', 'medium_check', 'large_arrow')
 * @param {string} [props.testId] - 테스트를 위한 ID
 * @param {string} [props.className] - 추가적인 CSS 클래스
 * @param {boolean} [props.solid=false] - 아이콘을 실선으로 표시할지 여부
 * @param {Function} [props.onClick] - 클릭 이벤트 핸들러
 *
 * @example
 * // 기본 사용법
 * <SystemIcon name="small_close" />
 *
 * // 커스텀 클래스와 함께 사용
 * <SystemIcon
 *   name="medium_check"
 *   className="text-blue-500"
 *   solid={true}
 * />
 *
 * // 클릭 이벤트와 함께 사용
 * <SystemIcon
 *   name="large_arrow"
 *   onClick={() => console.log('아이콘 클릭됨')}
 *   testId="arrow-icon"
 * />
 */ const SystemIcon = ({ name, testId, className, solid = false, onClick })=>{
    const sizeOfIcon = name.split('_')[0];
    const modifiedClassName = tailwindMerge.twMerge('text-w-gray-900', className);
    const IconComponent = (props)=>{
        if (sizeOfIcon === 'small') {
            const Icon = SystemIcon_constants.smallIcons.get(name);
            return Icon && jsxRuntime.jsx(Icon, Object.assign({}, props));
        }
        if (sizeOfIcon === 'medium') {
            const Icon = SystemIcon_constants.mediumIcons.get(name);
            return Icon && jsxRuntime.jsx(Icon, Object.assign({}, props));
        }
        if (sizeOfIcon === 'large') {
            const Icon = SystemIcon_constants.largeIcons.get(name);
            return Icon && jsxRuntime.jsx(Icon, Object.assign({}, props));
        }
        const Icon = SystemIcon_constants.socialIcons.get(name);
        return Icon && jsxRuntime.jsx(Icon, Object.assign({}, props));
    };
    return IconComponent && jsxRuntime.jsx(IconComponent, {
        className: modifiedClassName,
        testId: testId,
        solid: solid,
        onClick: onClick
    });
};

module.exports = SystemIcon;
